<template>
  <div>
    <vue-headful title="Profile" description="Profile" />

    <main role="main" class="main">
      <div class="profile-wrap user-profile-page" :class="{'profile-page-app': $store.state.isApp}">
        <div class="form-group profile-form-header">
          <h1>My Profile</h1>
          <div class="btn-logout">
            <logout-btn class="btn btn-success">
              <img src="/img/logout.svg" /> Log out
            </logout-btn>
          </div>
        </div>

        <hr class="hr" />

        <div class="profile-pic form-group">
          <label class="sa-label">Social account</label>
          <div v-if="profile.fb_id">
            <div class="pic">
              <img style="width: 80px" v-bind:src="profile.pic" />
            </div>

            <div v-if="edit == 'fb'" class="fb-button">
              <div @click="unlink_fb" class="btn btn-success btn-fb">
                <img src="/img/profile/facebook-white-icon.svg" />
                <span>Unlink from Facebook</span>
              </div>
              <div class="cancel-btn" style="padding-top: 30px">
                <a @click.prevent="e(null)">Cancel</a>
              </div>
              <div style="line-height: 20px">
                You must create a password before unlinking a social account
                otherwise your account will be inaccessible
              </div>
            </div>

            <!--            <fb-login style="top: 30px; width: auto;" v-else class="inp">-->
            <!--              Facebook account linked since {{ profile.fb_account_linked }}-->
            <!--            </fb-login>-->

            <span style="top: 30px; width: auto" v-else>
              Facebook account linked since {{ profile.fb_account_linked }}
            </span>

            <div
              v-if="edit != 'fb'"
              class="edit-btn"
              style="position: relative; top: 20px"
              @click="e('fb')"
            >
              <img src="/img/edit-pen.svg" />
            </div>
          </div>
          <div v-else class="fb-connect">
            <fb-login>
              <span>Login with Facebook</span>
            </fb-login>
            <div>For 1 click sign, you can link your facebook account</div>
          </div>
          <div style="clear: both"></div>
        </div>

        <!-- <hr class="hr" />

        <div class="profile-pic-form">
          <label>Profile pic</label>
          <div class="profile-pic-form__body">
            <img
              class="profile-image cursor-pointer"
              v-bind:src="$store.state.baseUrl + profile.pic"
              @click="$refs.uploadImage.click()"
            />
            <div>
              <input
                style="width: 0; height: 0; opacity: 0"
                ref="uploadImage"
                type="file"
                class="upload-avatar__field"
                accept="image/*"
                @input="uploadProfilePic($event)"
              />
              <button
                @click="$refs.uploadImage.click()"
                class="profile-pic-form__btn"
              >
                Upload picture
              </button>
              <button @click="deleteProfilePic()" class="profile-pic-form__btn">
                Delete picture
              </button>
            </div>
          </div>
        </div> -->

        <hr class="hr" />

        <form
          @submit.prevent="validateForm('form-email')"
          data-vv-scope="form-email"
        >
          <div class="form-group email">
            <label>Email</label>
            <div v-if="edit != 'email'" class="txt">
              {{ user.email }}
              <div
                v-if="email_change"
                class="error-danger"
                style="
                  color: #0b58a2;
                  width: 100%;
                  clear: both;
                  font-size: 15px;
                  margin-top: 10px;
                "
              >
                Waiting for e-mail change confirmation to
                <strong>{{ email_change.email }}</strong>
              </div>
            </div>
            <div v-if="edit == 'email'" class="inp">
              <input
                :class="[
                  'form-control',
                  { 'hes-error': errors.has('form-email.email') },
                ]"
                type="text"
                v-model="user.email"
                name="email"
                v-validate="'required|email'"
              />
              <div v-show="errors.has('form-email.email')" class="error">
                {{ errors.first("form-email.email") }}
              </div>
            </div>
            <div v-if="edit != 'email'" class="edit-btn" @click="e('email')">
              <img src="/img/edit-pen.svg" />
            </div>
            <div v-if="edit == 'email'" class="cancel-btn">
              <a class="btn btn-success" @click="changeEmailBtn('form-email')">
                Save changes</a
              >
              <a @click.prevent="e(null)">Cancel</a>
            </div>
            <div style="clear: both"></div>
          </div>
        </form>

        <hr class="hr" />

        <form
          @submit.prevent="validateForm('form-pass')"
          data-vv-scope="form-pass"
        >
          <div class="form-group">
            <label>Password</label>
            <div v-if="edit != 'password'">
              <div v-if="is_pass == 0" class="txt not-set">
                Password not set
              </div>
              <div v-else class="txt">********</div>
            </div>
            <div class="inp" v-if="edit == 'password'">
              <input
                :class="[
                  'form-control',
                  { 'hes-error': errors.has('form-pass.password') },
                ]"
                type="password"
                v-model="user.password"
                name="password"
                ref="password"
                v-validate="'required|min:6'"
              />

              <div v-show="errors.has('form-pass.password')" class="error">
                {{ errors.first("form-pass.password") }}
              </div>
            </div>
            <div
              v-if="edit != 'password'"
              class="edit-btn"
              @click="e('password')"
            >
              <img src="/img/edit-pen.svg" />
            </div>
            <div v-if="edit == 'password'" class="cancel-btn">
              <a class="btn btn-success" @click="changePass('form-pass')"
                >Save changes</a
              >
              <a @click.prevent="e(null)" href="#">Cancel</a>
            </div>
            <div style="clear: both"></div>
          </div>
          <div
            v-if="edit == 'password'"
            class="form-group"
            style="margin-top: 22px"
          >
            <label>Confirm Password</label>
            <div class="inp">
              <input
                :class="[
                  'form-control',
                  { 'hes-error': errors.has('form-pass.confirm_password') },
                ]"
                type="password"
                v-model="user.confirm_password"
                v-validate="'required|confirmed:password'"
                data-vv-as="password"
                name="confirm_password"
              />
              <div
                v-show="errors.has('form-pass.confirm_password')"
                class="error"
              >
                {{ errors.first("form-pass.confirm_password") }}
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </form>

        <hr class="hr" />

        <div class="form-group">
          <label>full name</label>
          <div
            v-if="edit != 'full_name'"
            v-bind:class="['txt', { 'not-set': !profile.full_name }]"
          >
            {{ profile.full_name ? profile.full_name : "Full Name not set" }}
          </div>
          <div v-if="edit == 'full_name'" class="inp">
            <input
              class="form-control"
              type="text"
              v-model="profile.full_name"
            />
          </div>
          <div
            v-if="edit != 'full_name'"
            class="edit-btn"
            @click="e('full_name')"
          >
            <img src="/img/edit-pen.svg" />
          </div>
          <div v-if="edit == 'full_name'" class="cancel-btn">
            <a class="btn btn-success" @click="save">Save changes</a>
            <a @click.prevent="e(null)" href="#">Cancel</a>
          </div>
          <div style="clear: both"></div>
        </div>

        <hr class="hr" />

        <div class="form-group">
          <label>Phone</label>
          <div
            v-if="edit != 'phone'"
            v-bind:class="['txt', { 'not-set': !profile.phone }]"
          >
            {{ profile.phone ? profile.phone : "Phone number not set" }}
          </div>
          <div v-if="edit == 'phone'" class="inp">
            <the-mask
              type="text"
              class="form-control"
              :mask="['### ####']"
              v-model="profile.phone"
            />
          </div>
          <div v-if="edit != 'phone'" class="edit-btn" @click="e('phone')">
            <img src="/img/edit-pen.svg" />
          </div>
          <div v-if="edit == 'phone'" class="cancel-btn">
            <a class="btn btn-success" @click="save">Save changes</a>
            <a @click.prevent="e(null)" href="#">Cancel</a>
          </div>
          <div style="clear: both"></div>
        </div>

        <hr class="hr" />

        <div class="form-group newsletter">
          <label class="no-top">Newsletter</label>
          <div class="txt">
            <label for="spam" class="checkbox-filter-label">
              <input
                type="checkbox"
                v-model="profile.spam"
                id="spam"
                @change="save"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint" @click="save"
                >Sign me up, no spam we promise!</span
              >
            </label>
          </div>
          <div style="clear: both"></div>
        </div>

        <hr class="hr" />

        <div class="form-group contact-me">
          <label style="float: none"
            >Allow car agents to contact me on saved cars?</label
          >
          <div>
            <label for="contact_by_email" class="checkbox-filter-label">
              <input
                type="checkbox"
                v-model="profile.contact_by_email"
                id="contact_by_email"
                @change="save"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">By email</span>
            </label>
            <label for="contact_by_phone" class="checkbox-filter-label">
              <input
                type="checkbox"
                v-model="profile.contact_by_phone"
                id="contact_by_phone"
                @change="save"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">By phone</span>
            </label>
          </div>
        </div>

        <hr
          class="hr"
          style="margin-top: 50px; margin-bottom: 40px; display: inline-block"
        />

        <div class="flex justify-between">
          <span
            >Your account was verified on {{ profile.account_verified }}</span
          >
          <a href="#" @click="del">Delete account</a>
        </div>
      </div>
        <Footer class="profile-footer" v-if="isIosApp" />
    </main>


<!--    pop ups-->
    <div v-if="status == 'del'" class="popupbg">
      <popup-del />
    </div>

    <div v-else-if="status == 'unlink'" class="popupbg">
      <popup-unlink-fb />
    </div>

    <div  v-else-if="status == 'pass-success'" class="popupbg">
        <popup-success
          :title="'Password changed'"
          :desc="'Password changed'"
          :btn="{ title: 'Innskrá', popup: 'sign-in' }"
        />
    </div>

    <div  v-else-if="status == 'email-success'" class="popupbg">
      <popup-success
        :title="'Email changed'"
        :desc="'Email changed'"
        :btn="{ title: 'Go to main page', url: '/' }"
      />
    </div>

    <div v-else-if="status == 'welcome'" class="popupbg">
      <welcome />
    </div>
  </div>
</template>

<script>
import PopUpDel from "../components/profile/PopUpDel.vue";
import PopUpUnlinkFb from "../components/profile/PopUpUnlinkFb.vue";
import PopUpSuccess from "../components/login/PopUpSuccess.vue";
import Welcome from "../components/profile/Welcome.vue";
import FbLogin from "../components/FbLogin.vue";
import Footer from "@/components/Footer";

import { TheMask } from "vue-the-mask";
import logoutBtn from "../components/login/LogoutBtn.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  data: function () {
    return {
      ph: "",
      status: null,
      user: [],
      profile: [],
      edit: [],
      is_pass: null,
      email_change: null,
    };
  },
  components: {
    "popup-del": PopUpDel,
    "popup-unlink-fb": PopUpUnlinkFb,
    "popup-success": PopUpSuccess,
    Welcome,
    TheMask,
    logoutBtn,
    FbLogin,
    Footer
  },
  computed:{
    ...mapGetters(["isIosApp"]),
  },
  methods: {
    ...mapActions("user", {
      saveProfile: "SAVEPROFILE",
      savePass: "SAVEPASS",
      changeEmail: "CHANGEEMAIL",
      getProfile: "PROFILE",
    }),
    uploadProfilePic(event) {
      const api = this.$store.state.api;
      const image = event.target.files[0];
      let formData = new FormData();
      formData.append("image", image);
      this.$refs.uploadImage.value = null;
      this.$http.post(`${api}/user/upload-image`, formData).then((response) => {
        if (response && response.data && response.data.success == true) {
          this.getProfile().then((response) => {
            let d = response.data;
            if (!d.user) {
              this.$router.push("/");
            }
            this.$store.state.profile.profile.pic = d.profile.pic;
            this.user = d.user;
            this.profile = d.profile;

            this.ph = this.profile.phone;

            if (
              !this.profile.full_name &&
              (this.profile.name || this.profile.surname)
            ) {
              this.profile.full_name =
                this.profile.name + " " + this.profile.surname;
            }
            this.email_change = d.email_change;
            this.is_pass = d.is_pass;
          });
        }
      });
    },
    deleteProfilePic() {
      const api = this.$store.state.api;
      this.$http.get(`${api}/user/delete-image`).then((response) => {
        if (response && response.data && response.data.success == true) {
          this.getProfile().then((response) => {
            let d = response.data;
            if (!d.user) {
              this.$router.push("/");
            }
            this.$store.state.profile.profile.pic = d.profile.pic;
            this.user = d.user;
            this.profile = d.profile;

            this.ph = this.profile.phone;

            if (
              !this.profile.full_name &&
              (this.profile.name || this.profile.surname)
            ) {
              this.profile.full_name =
                this.profile.name + " " + this.profile.surname;
            }
            this.email_change = d.email_change;
            this.is_pass = d.is_pass;
          });
        }
      });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          // eslint-disable-next-line
          alert("Form Submitted!");
        }
      });
    },
    e(param) {
      if (!param) {
        this.init();
      }

      this.edit = param;
    },
    del: function () {
      this.$store.state.status = "del";
    },
    unlink_fb: function () {
      this.$store.state.status = "unlink";
    },
    save: function () {
      let profile = this.profile;
      let th = this;

      //axios.post('/user/profile-save',{profile:profile})
      this.saveProfile({ profile: profile }).then((r) => {
        if (r.data.status == "ok") {
          th.edit = null;
        }
      });
    },
    savePassEvent() {
      let data = { password: this.user.password };

      this.savePass(data).then((response) => {
        if (response.data.status == true) {
          this.edit = null;
          this.$store.state.status = "pass-success";
        }
      });
    },
    changePass(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return this.savePassEvent();
        }
      });
    },
    saveEmail() {
      let data = { email: this.user.email };
      this.changeEmail(data).then((response) => {
        if (response.data.status == "ok") {
          this.edit = null;
          this.init();
        } else {
          this.$validator.errors.add({
            field: "form-email.email",
            msg: response.body.errors.email,
          });
        }
      });
    },
    changeEmailBtn(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          return this.saveEmail();
        }
      });
    },
    init: function () {
      this.getProfile().then((response) => {
        let d = response.data;
        if (!d.user) {
          this.$router.push("/");
        }

        this.user = d.user;
        this.profile = d.profile;

        this.ph = this.profile.phone;

        if (
          !this.profile.full_name &&
          (this.profile.name || this.profile.surname)
        ) {
          this.profile.full_name =
            this.profile.name + " " + this.profile.surname;
        }
        this.email_change = d.email_change;
        this.is_pass = d.is_pass;
      });
    },
  },

  watch: {
    "$store.state.popup": function () {
      this.$store.state.status = null;
    },
    "$store.state.status": function (o, n) {
      this.status = this.$store.state.status;
      if (o == null && n == "unlink") {
        this.init();
      }
    },
  },
  created: function () {
    if (Object.keys(this.$route.query).length) {
      this.$store.state.status = this.$route.query.s;
      this.$router.push("/profiles");
    }
    this.init();
  },
};
</script>

<style lang="less" scoped>
.profile-page-app {
  @media (max-width: 720px) {
    margin-top: -130px;
  }
}
.profile-form-header {
  padding-top: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.profile-pic-form {
  display: flex;
  align-items: center;
}
.profile-pic-form label {
  top: 0;
}
.profile-pic-form__body {
  display: flex;
  align-items: center;
  width: calc(100% - 70px);
  justify-content: space-between;
}
.profile-image {
  max-width: 80px;
  margin-left: 10px;
  height: 80px;
  width: 80px;
  max-height: 80px;
  object-fit: cover;
  border-radius: 100%;
}
.profile-pic-form__btn {
  background: none;
  border: none;
  outline: none;
  font-weight: normal;
  color: #3f51ae;
  margin-left: 10px;
  cursor: pointer;
}
</style>